import { IContentInfo } from '../../../ts/models/IContentInfo';
import { INamedItemInfo } from '../../../ts/models/resourceInfoParts';
import { DetailsTooltipStyles } from '../CardView/DetailsTooltipStyles';
import { SpacesSiteUrls } from '../SpacesSiteUrls';
import { EntityLinkProps } from './Elements/EntityLink';

export interface ContentTooltipProps {
  content: IContentInfo;
  urls: SpacesSiteUrls;
  inProjectSpace?: boolean;
  lastUpdatedTimestamp?: Date;
}

export const TooltipDescriptionTestId = 'tooltip-description-field';

export const ContentDescriptionClassNames = [
  'tb-textile',
  'tb-textile-preview-container',
  DetailsTooltipStyles.MetadataValueContentDescription
].join(' ');

export const getProjectLink = (project: INamedItemInfo, urls: SpacesSiteUrls) : EntityLinkProps => {
  return project ? {
    href: urls.projectUrl(project.id),
    iconImagePath: null,
    name: project.name
  } : null;
};
